/**
 * Created by Jose Andres on 02.23.17
 */

export * from './odometer.component';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
